<script lang="ts">
	import { defineComponent } from "vue";
	import BannerCampus from "../components/landing/BannerCampusSlider.vue";
    import FormarBloqueLanding from "../components/landing/FormarBloqueLanding.vue";
    import Oferta from "../components/landing/Oferta.vue";
    import Ubicacion from "../components/landing/Ubicacion.vue";
    import Instalaciones from "../components/landing/Instalaciones.vue";
	// import ModelosEducativos from "../components/landing/ModelosEducativos.vue";
	// import OfertaEducativa from "../components/landing/OfertaEducativa.vue";
	// import HumanitasMuchoMas from "@/components/HumanitasMuchoMas.vue";


	export default defineComponent({
		name: "CampusAngelopolis",
		components: {
			BannerCampus,
            FormarBloqueLanding,
            Oferta,
            Ubicacion,
            Instalaciones
		},
		props: {
			campus: {
				type: String,
				required: true,
			},
			banner: {
				type: String,
				required: true,
			},
        },
        data() {
            return {
                currentImage: 0,
                currentImage2: 0,
                images: [
                    '/pagesImages/angelopolis-instalaciones-1.webp',
                    '/pagesImages/angelopolis-instalaciones-2.webp',
                ],
                images2: [
                    '/pagesImages/angelopolis-instalaciones-3.webp',
                    "/pagesImages/angelopolis-instalaciones-4.webp",
                ],
                alts: [
                    'Oficinas y salones de campus ejecutivo Angelópolis',
                    'Oficinas y salones de campus ejecutivo Angelópolis',
                    'Oficinas y salones de campus ejecutivo Angelópolis',
                    'Oficinas y salones de campus ejecutivo Angelópolis'
                ],
                imagesArray: [
                    "/pagesImages/encabezado-landing-Angelopolis.webp",
                ],
                altArray: [
                    "Fotos de campus ejecutivo Angelópolis",
                    "Fotos de campus ejecutivo Angelópolis",
                ],
                tour: [
                    { src:"/pagesImages/tour-Monterrey-1.webp", title:"Tour virtual en Campus ejecutivo Angelópolis"},
                    { src:"/pagesImages/tour-Monterrey-2.webp", title:"Tour virtual en Campus ejecutivo Angelópolis"},
                    { src:"/pagesImages/tour-Monterrey-3.webp", title:"Tour virtual en Campus ejecutivo Angelópolis"},
                    { src:"/pagesImages/tour-Monterrey-4.webp", title:"Tour virtual en Campus ejecutivo Angelópolis"},
                ],
                campusName: "ANGELÓPOLIS",
                campusType: "CAMPUS EJECUTIVO",
                localidad: "Puebla",
                frase: "Solo es libre quien vive conforme a la razón y comprende la naturaleza de las cosas",
                autor: "Epicteto",
            }
        },
        methods: {
            nextImage() {
                this.currentImage = (this.currentImage + 1) % this.images.length
            },
            nextImage2() {
                this.currentImage2 = (this.currentImage2 + 1) % this.images2.length
            }
        }
	});
</script>

<template>
	<!-- <BannerCampus :banner="banner"/> -->
    <BannerCampus :campusType="campusType" :campus="campusName" :localidad="localidad" :slider="imagesArray" :alt="altArray" :frase="frase" :autor="autor" :banner="banner"/>
    <FormarBloqueLanding :frase="'Campus Ejecutivo'" :testo1="'El campus ejecutivo se localiza en un edificio corporativo con amenidades de alto nivel, concebidas para brindar una experiencia funcional, cómoda y alineada con las exigencias actuales del entorno académico y corporativo.'" :testo2="'Su integración dentro de un desarrollo de usos mixtos con altos estándares arquitectónicos, refuerza su propuesta de valor al combinar eficiencia operativa, imagen institucional y plusvalía.'" :testo3="'Ubicado en una de las zonas más vanguardistas de Puebla, ofrece una localización estratégica que combina modernidad y dinamismo.'" :img="'/pagesImages/angelopolis-una-mirada.webp'" :alt="'Foto panorámica de campus ejecutivo Angelópolis'" class="mb-16" />
    <div class="flex items-center justify-center w-full mb-16 relative">
        <div class="flex flex-col items-center justify-center w-full max-w-4xl lg:max-w-[1200px] lg:px-0 px-8">
            <h2 class=" text-hgold text-center font-serif md:text-[42px] text-[32px] mb-8 leading-none w-full">Instalaciones</h2>
            <p class="text-center mb-8">Diseñadas bajo un enfoque corporativo contemporáneo, proyecta entornos<br class="lg:block hidden"> versátiles que integran confort, tecnología y adaptabilidad.</p>
            <div class="flex flex-col justify-between">
                <div class="lg:flex items-center justify-center mb-16">
                    <div class="lg:w-[50%] text-justify mb-8 lg:mb-0 lg:mr-12 space-y-8">
                        <div class="flex flex-col">
                            <h3 class="text-lg text-left uppercase w-full">Aulas interactivas</h3>
                            <p class="text-justify lg:hyphens-none hyphens-auto">Los salones cuentan con proyectores y sistemas de audio para clases dinámicas e interactivas.</p>
                        </div>
                        <div class="flex flex-col">
                            <h3 class="text-lg text-left uppercase w-full">Áreas especializadas</h3>
                            <p class="text-justify lg:hyphens-none hyphens-auto">El campus cuenta con áreas especializadas diseñadas para enriquecer la formación, entre ellas se incluyen espacios adaptados para disciplinas como Derecho y Psicología, con cámara Gesell y sala de juicios orales, orientadas a la simulación de escenarios reales.</p>
                        </div>
                    </div>
                    <div class="flex items-center justify-center w-full lg:max-w-[520px] relative">
                        <img
                        :src="images[currentImage]"
                        alt="Instalaciones de Campus Ejecutivo Angelópolis"
                        class="w-full lg:max-w-[520px]"
                        />
                        <button
                        @click="nextImage"
                        class="absolute top-1/2 right-2 transform -translate-y-1/2 bg-white/50 text-black focus:outline-none px-4 p-2 rounded-full hover:bg-white/30 transition"
                        >
                        &gt;
                        </button>
                    </div>
                </div>
            </div>
            <div class="flex flex-col justify-between">
                <div class="flex lg:flex-row flex-col items-center justify-center">
                    <div class="flex lg:order-1 order-2 items-center justify-center w-full lg:max-w-[520px] relative">
                        <img
                        :src="images2[currentImage2]"
                        alt="Jardines de Campus Ejecutivo Angelópolis?"
                        class="w-full lg:max-w-[520px]"
                        />
                        <button
                        @click="nextImage2"
                        class="absolute top-1/2 right-2 transform -translate-y-1/2 bg-white/50 text-black focus:outline-none px-4 p-2 rounded-full hover:bg-white/30 transition"
                        >
                        &gt;
                        </button>
                    </div>
                    <div class="lg:w-[50%] order-1 lg:order-2 text-justify mb-8 lg:mb-0 lg:ml-12 space-y-8">
                        <div class="flex flex-col">
                            <h3 class="text-lg text-left uppercase w-full">Biblioteca y recursos digitales</h3>
                            <p class="text-justify lg:hyphens-none hyphens-auto">Con acceso a libros físicos, bases de datos digitales y computadoras. Este espacio fomenta el estudio en un entorno cómodo y bien equipado.</p>
                        </div>
                        <div class="flex flex-col">
                            <h3 class="text-lg text-left uppercase w-full">Oficinas ejecutivas</h3>
                            <p class="text-justify lg:hyphens-none hyphens-auto">Son espacios que se adaptan al mundo corporativo con sesiones de mentoría, asesorías personalizadas y trabajo colaborativo.</p>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div class="grid lg:grid-cols-2 grid-cols-1 gap-10">
                
            </div> -->
        </div>
    </div>
    <h2 class="text-hgold text-center font-serif md:text-[42px] text-[32px] lg:px-0 px-8 lg:mb-4 leading-none w-full">Oferta académica en Campus Angelópolis</h2>
    <Oferta :virtual=false :visibleOffers="{
        Licenciaturas: ['Administración', 'Contabilidad', 'Psicología' , 'Derecho'],
        Maestrías: ['Alta Dirección', 'Derecho Corporativo', 'Psicoterapia con un<br> enfoque Psicoanalítico', ]
    }" class="flex items-center justify-center" />

    <div class="flex items-center justify-center w-full mb-16 mt-6 relative">
        <div class="flex flex-col items-center justify-center w-full max-w-4xl lg:max-w-[1200px] lg:px-0 px-8">
            <h2 class=" text-hgold text-center font-serif md:text-[42px] text-[32px] mb-16 leading-none w-full">Nuestros modelos educativos</h2>
            <section class="flex items-center justify-center w-full">
                <div class="lg:flex flex-col px-4 items-center w-full max-w-4xl lg:max-w-[1200px] justify-start">
                    <div class="flex flex-col justify-between">
                        <div class="lg:flex items-center justify-center">
                            <div class="flex items-center justify-center w-full lg:max-w-[520px]" style="border">
                                <img src="/pagesImages/mujer-modelo-ejecutivo-universidad-humanitas.webp" alt="Modelo ejecutivo en Universidad Humanitas" class="w-full lg:max-w-[520px]"/>
                            </div>
                            <div class="lg:w-[50%] text-justify my-8 lg:my-0 lg:ml-12">
                                <h3>
                                    <!-- <span class="block text-[#73793B] leading-none text-left text-[28px]" style=""></span>
                                    <span class="sr-only whitespace-nowrap">&nbsp;</span> -->
                                    <span class="block text-hgold text-left font-serif mb-3 text-3xl md:text-4xl">Modelo ejecutivo</span>
                                </h3>
                                <p class=" lg:hyphens-none hyphens-auto">
                                    Está diseñado para brindar flexibilidad sin comprometer la calidad académica. Los programas se estructuran en bloques trimestrales, cada uno fusionando tres materias, impartidas por especialistas. Requiere autodisciplina, gestión eficiente del tiempo y compromiso con el éxito académico.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section class="flex items-center justify-center w-full">
                <div class="lg:flex flex-col px-4 items-center w-full max-w-4xl lg:max-w-[1200px] justify-start">
                    <div class="flex flex-col justify-between">
                        <div class="lg:flex items-center justify-center">
                            <div class="lg:w-[50%] text-justify mb-8 lg:mb-0 lg:mr-12">
                                <h3>
                                    <span class="block text-hgold text-left font-serif mb-3 text-3xl md:text-4xl">Modelo escolarizado</span>
                                </h3>
                                <p class="lg:hyphens-none hyphens-auto">
                                    Ofrece una formación académica de calidad con un enfoque práctico y humano. Cada licenciatura está diseñada con objetividad e integrada con talleres y seminarios, que potencian la preparación para enfrentar los desafíos del mundo actual con conocimiento, habilidades y experiencia.
                                </p>
                            </div>
                            <div class="flex items-center justify-center w-full lg:max-w-[520px]">
                                <img src="/pagesImages/alumnos-sistema-escolarizado-universidad-humanitas.webp" alt="Estudiante modelo escolarizado en Universidad Humanitas" class="w-full lg:max-w-[520px]"/>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
    <!-- <div class="flex items-center justify-center w-full mb-16 relative">
        <div class="flex flex-col items-center justify-center w-full max-w-4xl lg:max-w-[1200px] lg:px-0 px-8">
            <h2 class=" text-hgold text-center font-serif md:text-[42px] text-[32px] mb-8 leading-none w-full">Galería</h2>
            <p class="mb-10">Conoce el Campus Ejecutivo Angelópolis</p>
            <Instalaciones :items="tour" class="mb-8" /> -->
            <!-- <iframe width="1140" height="641" src="https://www.youtube.com/embed/qBOIBjsj3RE" title="Monterrey" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe> -->
        <!-- </div>
    </div> -->
    <Ubicacion :campus="'Campus Ejecutivo Angelópolis'" :mapa="'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3772.502535848814!2d-98.2795986!3d18.997564999999998!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85cfb9ce4816d0a7%3A0x9bc7f3d658d0e04c!2sUniversidad%20Humanitas%20Campus%20Angel%C3%B3polis!5e0!3m2!1ses-419!2smx!4v1781807221775!5m2!1ses-419!2smx'" :testo1="'Para llegar al campus en transporte público, se consideran las siguientes líneas de autobús: A6, corredor Atlixcayotl, ruta Azteca b y c, ruta Lomas de Angelópolis y ruta Puebla.'" :testo3="'En caso de utilizar automóvil las vías rápidas son: Boulevard Atlixcáyotl, Periférico Ecológico y Avenida Atlixco, así como la Calzada Zavaleta, la Avenida San Baltazar (Juan Pablo II) y la incorporación a la autopista México-Puebla.'" :ubicacion="'Torre Elementa, Local 7, Blvd. América 303, Lomas de Angelópolis, San Bernardino,C.P. 72830, Tlaxcalancingo, Puebla'" :telefono="'222-241-9240'" class="lg:px-0 px-8" />
	<!-- <BienvenidosCampus
		:frase="'El único modo de hacer un gran trabajo es amar lo que haces'"
		:autor="'Steve Jobs'"
		:line1="'Camino Viejo a Madín 38-B'"
		:line2="'Colonia Viejo Madín,'"
		:line3="'Cd. López Mateos'"
		:line4="'C.P. 52989'"
		:line5="'Estado de México'"
		:line6="''"
		:mapslink="'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d7520.492114723999!2d-99.263648!3d19.531047!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85d21cb0eb704871%3A0xd6d88f92b654e1dd!2sUniversidad%20Humanitas%20Campus%20Presa%20Mad%C3%ADn!5e0!3m2!1ses!2smx!4v1738217853369!5m2!1ses!2smx'"
	/>

	<ModelosEducativos />

	<OfertaEducativa />

	<HumanitasMuchoMas /> -->
</template>

<style scoped>
</style>